import * as React from 'react';
/**
 * @ignore - internal component.
 */
const ToggleButtonGroupButtonContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ToggleButtonGroupButtonContext.displayName = 'ToggleButtonGroupButtonContext';
}
export default ToggleButtonGroupButtonContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ToggleButtonGroup/ToggleButtonGroupButtonContext.js
// module id = 976
// module chunks = 25